module.exports = __webpack_public_path__ + "img/dad-mobile-details.ebfb3498.jpg";